/**
 * DevExtreme (esm/__internal/grids/new/grid_core/columns_controller/columns_settings/extract_columns_options_change.js)
 * Version: 25.1.4
 * Build date: Tue Aug 05 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
import {
    getPathParts
} from "../../../../../../core/utils/data";
import {
    getColumnIdxFromPath,
    getColumnOptionPathStr,
    isAllowedColumnValue,
    isCorrectColumnIdx
} from "./utils";
const ROOT_COLUMNS_OPTION_NAME = "columns";
export const extractColumnsOptionsChange = _ref => {
    let {
        fullName: fullName,
        value: value
    } = _ref;
    const updatePath = getPathParts(fullName);
    const [rootUpdatePath] = updatePath;
    switch (true) {
        case "columns" !== rootUpdatePath:
            return null;
        case 1 === updatePath.length && Array.isArray(value):
            return {
                type: "allColumns", value: value ?? null
            };
        case 2 === updatePath.length && isAllowedColumnValue(value) && isCorrectColumnIdx(updatePath[1]):
            return {
                type: "column", columnIdx: getColumnIdxFromPath(updatePath), value: value
            };
        case updatePath.length > 2 && isCorrectColumnIdx(updatePath[1]):
            return {
                type: "columnOption", columnIdx: getColumnIdxFromPath(updatePath), optionPath: getColumnOptionPathStr(updatePath), value: value
            };
        default:
            return null
    }
};
